import dayjs from 'dayjs';

export interface DateRange {
  from: string;
  to: string;
}

/**
 * Liệt kê ĐỦ các ngày trong khoảng, id `YYYY-MM-DD` để khớp thẳng `item.menu_date`.
 *
 * Cố tình không lọc theo ngày có suất ăn: ô "Ngày ăn thực tế" phải liệt kê đủ ngày của tuần, chọn
 * phải ngày trống rồi thấy bảng trống là thông tin, không phải lỗi.
 */
export const buildDayOptions = (range?: DateRange | null): { id: string; name: string }[] => {
  if (!range?.from || !range?.to) return [];

  const days: { id: string; name: string }[] = [];
  let cursor = dayjs(range.from);
  const last = dayjs(range.to);
  while (cursor.isBefore(last) || cursor.isSame(last, 'day')) {
    days.push({ id: cursor.format('YYYY-MM-DD'), name: cursor.format('DD/MM/YYYY') });
    cursor = cursor.add(1, 'day');
  }
  return days;
};
